//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[],[[["workpiece"],"SetWorkpiece",{},1,0],[["network"],"SetNetwork",{},1,0],[["name"],"SetFixtureName",{},1,0],[["fixtureStep"],"SetFixtureStep",{},1,0],[[],"GetFixtureStep",{R_:{fixtureStep:''}},0,0],[[],"GetMinFixtureStep",{R_:{minStep:''}},0,0],[[],"GetMaxFixtureStep",{R_:{maxStep:''}},0,0],[[],"GetBottomOffset",{R_:{offset:''}},0,0],[["offset"],"SetBottomOffset",{},1,0],[[],"GetRotationStep",{R_:{rotStep:''}},0,0],[["rotStep"],"SetRotationStep",{},1,0],[[],"GetTiltStep",{R_:{tiltStep:''}},0,0],[["tiltStep"],"SetTiltStep",{},1,0],[[],"UpdateFixture",{},0,0],[[],"GetSideOffset",{R_:{offset:''}},0,0],[["offset"],"SetSideOffset",{},1,0],[[],"GetFixture",{R_:{fixture:"Assemblies.Assembly"}},0,0],[["fixture"],"DeleteFixture",{},1,0]],[]];
SPLM.CAM.InsertFixture = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InsertFixture";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InsertFixture.WorkpieceType = Object.freeze({
    "BoundingBlock" : "BoundingBlock", "BoundingCylinder" : "BoundingCylinder"});

SPLM.CAM.InsertFixture.Rotation = Object.freeze({
    "Degree0" : "Degree0", "Degree90" : "Degree90", "Degree180" : "Degree180", "Degree270" : "Degree270"});

export default SPLM;